import React from 'react';
import useAppSelector from '../../app/redux/useAppSelector';
import Modal from '../../components/Modal';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import { useGetUser } from '../useAllUsers';
import UserProfileSettingsForm from './UserProfileSettingsForm';

const USER_FRAGMENT = gql(`
  fragment UserProfileSettingsModal_user on User {
    id
    ...useGetUser_user
  }
`);

interface UserProfileSettingsModalProps {
  close: () => void;
  user: DocumentType<typeof USER_FRAGMENT>;
}

const UserProfileSettingsModal = ({
  close,
  user,
}: UserProfileSettingsModalProps) => {
  const getUser = useGetUser();
  const currentUser = useAppSelector((state) => state.session.user);

  return (
    <Modal
      variant="expanded"
      title={
        currentUser.id === user.id ? 'Edit my profile' : 'Edit user profile'
      }
      close={close}
    >
      <UserProfileSettingsForm
        user={getUser(user)}
        onComplete={() => close()}
      />
    </Modal>
  );
};

export default UserProfileSettingsModal;
